import React from "react";
import { Provider } from "react-redux";
import AppContainer from "./src/components/AppContainer";

import "./src/styles/custom.css";

import "./src/components/ImageCreator/style.scss";
import "./src/components/ImagePreview/style.scss";
import "./src/components/TextSubmitterForm/style.scss";
import "./src/components/Modal/style.scss";
import "./src/components/Editor/style.scss";
import "./src/components/Tools/EditorV2/editor.scss";
import "./src/components/Header/style.scss";
import "./src/components/Share/style.scss";
import "./src/components/GenerationCount/style.scss";
import "./src/components/TodaysContent/style.scss";
import "./src/components/AppContainer/style.scss";
import "./src/components/Loader/style.scss";
import "./src/components/Blogs/style.scss";
import "./src/components/ChromeExtension/style.scss";

import "./src/styles/style.scss";

import store from "./src/store";

export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <AppContainer>{element}</AppContainer>
    </Provider>
  );
};

export const onClientEntry = () => {
  // Helper to add script to head
  function addScript({ src, async = false, innerHTML, attrs = {} }) {
    const script = document.createElement('script');
    if (src) script.src = src;
    if (async) script.async = true;
    if (innerHTML) script.innerHTML = innerHTML;
    Object.entries(attrs).forEach(([key, value]) => script.setAttribute(key, value));
    document.head.appendChild(script);
  }

  addScript({ src: "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js", attrs: { integrity: "sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM", crossorigin: "anonymous" } });
  addScript({ src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8150277115778421", async: true, attrs: { crossorigin: "anonymous" } });
  addScript({ src: "https://cmp.gatekeeperconsent.com/min.js", attrs: { "data-cfasync": "false" } });
  addScript({ src: "https://the.gatekeeperconsent.com/cmp.min.js", attrs: { "data-cfasync": "false" } });
  addScript({ innerHTML: "window.ezstandalone = window.ezstandalone || {}; ezstandalone.cmd = ezstandalone.cmd || [];" });

};
